<template>
  <!-- begin:: Header Topbar -->
  <div class="ml-topbar">

    <div v-if="isMobile">
      <m-row>
        <m-row>
          <m-col sm="12">
            <div class="ml-topbar-right">
              <LanguageDropdown />
              <UserMenuDropdown />
              <button class="ml-hamburger" v-if="isMobile" @click="$emit('toggle_menu')">
                &#9776;
              </button>
            </div>
          </m-col>
        </m-row>
        
        <m-col sm="12">
          <QuickSearchWidget />
        </m-col>
      </m-row>
      <m-row>
        <m-col sm="12">
          <UserDropdowns />
        </m-col>
      </m-row>
      <m-row>
        <m-col sm="12">
          
        </m-col>
      </m-row>
      
    </div>
    <div v-else>
      <m-row class="mt-2">
        <m-col lg="5">
          <UserDropdowns class="mt-2" />
        </m-col>
        <m-col lg="4">
          <QuickSearchWidget class="mt-2"/>
        </m-col>
        <m-col lg="3">
          <div class="ml-topbar-right">
            <LanguageDropdown />
            <UserMenuDropdown />
          </div>
        </m-col>
      </m-row>
    </div>

    <memlist-modal size="lg" ref="notification-popup">

    <div class="d-flex flex-column">
      <div class="w-100 h-100 align-items-center text-center flex-wrap justify-content-center">
        <i class="fa fa-exclamation-triangle" style="font-size: 42px; color: #eca350;"></i>
      </div>

      <hr />

      <div>

        <div>
          <div class="h-100 align-items-center text-center flex-wrap justify-content-center">
            <h4 class="header-name mt-8" style="text-align: center; min-width: 512px;">{{ $t('USER.NOT_LOGGED_IN') }}</h4>
            <br />
            <p class="mt-8">{{ $t('USER.YOU_ARE_NOT_LOGGED_IN') }}</p>
            
            <p class="mt-8"><memlist-button variant="success" @click.prevent="clicked_goto_login()">{{$t('USER.GOTO_LOGIN')}}</memlist-button></p>
          </div>
        </div>

      </div>

  </div>
</memlist-modal>

<!--end: User Bar -->
</div>
  <!-- end:: Header Topbar -->
</template>


<script>

import i18nService from '@/core/services/i18n.service.js';
import store from '@/core/services/store';
import QuickSearchWidget from '@/view/components/QuickSearchWidget.vue';
import UserMenuDropdown from './UserMenuDropdown.vue';
import { PURGE_AUTH } from '@/core/services/store/auth.module';
import { mapGetters } from 'vuex';
import { LOGOUT } from '@/core/services/store/auth.module';
import { parseJwt } from '@/core/services/jwt.service';
import dayjs from 'dayjs';

import LanguageDropdown from './LanguageDropdown.vue'
import UserDropdowns from './UserDropdowns.vue';

function pad(num) {
  if (parseInt(num) < 10) {
    return '0'+num;
  }

  return num;
}

export default {
  name: 'UserTopbar',
  emits: ['toggle_menu'],
  data() {
    return {
      isMobile: false,
      timer: null,
      currentTime: null,
      languageFlag: '',
      languages: i18nService.languages
    };
  },
  props: {
    
  },
  components: {
    LanguageDropdown,
    QuickSearchWidget,
    UserMenuDropdown,
    UserDropdowns,
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'user_refresh_token', 'user']),

    getLanguageFlag() {
      return this.onLanguageChanged();
    },
    
    session_expires_in() {
      const parsed = parseJwt(this.user_refresh_token);
      const expiration = dayjs.unix(parsed.exp);
      
      // Calculate the difference in milliseconds
      const diff = expiration.diff(this.currentTime);

      // Extract days, hours, minutes, and seconds
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (isNaN(days)) {
        return this.$t('COMMON.LOADING');
      }

      if (diff < 0) {
        setTimeout(() => {
          this.show_popup(diff < 0);
        }, 2000);

        return this.$t('COMMON.LOADING');
      }

      return this.$t('COMMON.SESSION_EXPIRES_IN', { days, hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) });
    },
  },

  mounted() {
    this.checkViewport();

    this.timer = setInterval(() => {
      this.currentTime = dayjs();
    }, 200);
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed
    clearInterval(this.timer);
  },
  methods: {

    checkViewport() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) this.menuOpen = false;
    },
    
    clicked_goto_login() {
      window.location.reload();
    },

    show_popup(show) {
      if (!show) { return; }
      
      this.$refs['notification-popup'].show();
    },

    onMyProfile() {
      // we dont care about this error message
      this.$router.push({ name: 'ml-profile' }).catch(()=>{});
    },
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
    onLogOut() {
      console.log('>> User initiated auth purge');
      const company_id = store.getters['sid'];

      this.$store.dispatch(LOGOUT);
      this.$store.commit(PURGE_AUTH);

      console.error('Topbar.vue: onLogOut', company_id);

      this.$router.push('ml-login')
    }
  },
  
};
</script>


<style lang="scss">

.ml-topbar-right {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
}

.ml-topbar {
  display: flex;
  flex-direction: column; // ensure rows stack on small screens
  align-items: stretch;
  justify-content: flex-start;
  background-color: #fff;
  gap: 16px;
}

.ml-hamburger {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 1rem;
}
</style>
